const part = [
    // {
    //     path: 'productApprove-list',
    //     name: 'productApprove-list',
    //     meta: {
    //         icon: 'md-cube',
    //         title: '产品审批记录',
    //         notCache: false,
    //         access: ['B', 'C'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/product-management/productApprove-management/productApprove-list')
    // },
    {
        path: 'productApprove-create',
        name: 'productApprove-create',
        meta: {
            icon: 'md-cube',
            title: '产品审批',
            notCache: true,
            hideInMenu: true,
            access: ['B', 'C'],
            items: [
            ]
        },
        component: () => import('@/view/product-management/productApprove-management/productApprove-create')
    },
    {
        path: 'productApprove-detail',
        name: 'productApprove-detail',
        meta: {
            icon: 'md-cube',
            title: '产品审批详情',
            notCache: true,
            hideInMenu: true,
            access: ['B', 'C', 'A', 'S'],
            items: [
            ]
        },
        component: () => import('@/view/product-management/productApprove-management/productApprove-detail')
    }
];

export default part;
